export default __webpack_public_path__ + "static/media/k.932e63ae.mp4";